import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { useAuthState } from "../../../../../../../../Helper/Context";
import { HeaderIllegal } from "../../../../IllegalConstructionDashboard/HeaderIllegal";
import { Loading } from "../../../../../../../../Helper/Loading";
import EnchrochmentSidebar from "../../../EnchrochmentSidebar/EnchrochmentSidebar";
import ViewURL from "../Modal/ViewURL";
import ReceivedComplaintAcknowledgePopUp from "../../../../IllegalConstructionDashboard/ReceivedComplaintIllegalGrid/Modal/ReceivedComplaintAcknowledgePopUp";
import ReturnPopUp from "../../../../IllegalConstructionDashboard/ReceivedComplaintIllegalGrid/Modal/ReturnPopUp";
import { ZoneNameCommanDDL } from "../../../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { Pegination } from "../../../../../../../../Components/Pegination/Pegination";
import { AcknowledgedComplaintGetTableDataAPI } from "../../../../../../../../Redux/EnchrochmentDashboardSlice/ComplaintStatusOfficialsSlice/AcknowledgedComplaintSlice";

export const ReceivedComplaintGrid = () => {

    // add
    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails

    const { t } = useTranslation()

    const [searchParams] = useSearchParams()

    let ZoneID = searchParams.get("ZoneID")
    let ZoneName = searchParams.get("ZoneName")
    // let ZoneValue = searchParams.get("ZoneValue");
    let DashSelect = searchParams.get("DashSelect");
    let Flag = searchParams.get("Flag");


    const [IsPost, setIsPost] = useState(false)

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)

    const [FromDate, setFromDate] = useState('')
    const [ToDate, setToDate] = useState('')

    const [SingleRawID, setSingleRawID] = useState([])
    const [SingleRawData, setSingleRawData] = useState([])
    const [IsCheckRemove, setIsCheckRemove] = useState(false)



    // ------------header DDL ------------

    const [YearValue, setYearValue] = useState(sessionStorage.getItem('yearId'))
    const [YearLabel, setYearLabel] = useState(sessionStorage.getItem('yearLable'))
    const [MonthValue, setMonthValue] = useState(sessionStorage.getItem('monthId'))
    const [MonthLabel, setMonthLabel] = useState(sessionStorage.getItem('monthLable'))
    const [ZoneValue, setZoneValue] = useState(sessionStorage.getItem('zoneId'))
    const [ZoneLabel, setZoneLabel] = useState(sessionStorage.getItem('ZoneLable'))

    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };

    // ----------Acknowledge PopUp ---------

    const [AcknowledgePopUpShow, setAcknowledgePopUpShow] = useState(false)

    const handleAcknowledge = () => {
        setAcknowledgePopUpShow(!AcknowledgePopUpShow)
    }

    // ------------ Return PopUp -------------
    const [ReturnPopUpShow, setReturnPopUpShow] = useState(false)
    const [GridData, setGridData] = useState([])

    const handleReturn = (data) => {
        setReturnPopUpShow(!ReturnPopUpShow)
        setGridData(data)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: ZoneID && ZoneID ? ZoneID : '0',
        Label: ZoneName && ZoneName ? ZoneName : "Select...",
    })

    // const [WardName, setWardName] = useState({
    //     DDL: [],
    //     ID: HWard && HWard ? HWard : '0',
    //     Label: WLable && WLable ? WLable : "Select...",
    // })

    const [WardNameID, setWardNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleIsPost = () => {
        setAcknowledgePopUpShow(false)
        setIsPost(!IsPost)
    }
    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setFromDate('')
        setToDate('')
        setZoneNameID({
            ...ZoneNameID,
            ID: 0,
            Label: 'Select...'
        })
        setWardNameID({
            ...WardNameID,
            ID: 0,
            Label: 'Select...'
        })
    }
    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [ZoneNameID.ID, WardNameID.ID])

    useEffect(() => {
        setIsCheckRemove(false)
        const data = {
            M_FinacialYearID: YearValue,
            M_MonthID: MonthValue,
            FromDate: FromDate,
            ToDate: ToDate,
            M_ZoneID: ZoneNameID.ID ? ZoneNameID.ID : ZoneValue,
            M_WardID: WardNameID.ID,
            T_ComplaintDetailsID: 0,
            M_WorkTypeID: DashSelect,
            Language: Language.Label,
            M_UserID: UserID,
            FromTop: From,
            ToTop: To,
            token: token,
            Flag: Flag,
            handleSetData: handleSetData
        }
        if (Language.Label != null) {
            dispatch(AcknowledgedComplaintGetTableDataAPI({ data }))
        }
    }, [YearValue, MonthValue, DashSelect, From, IsClear, IsSearch, IsPost, Language.Label, FromDate, ToDate, ZoneValue, ZoneNameID.ID, WardNameID.ID])

    const { isLoading, tableData } = useSelector(state => state.AcknowledgedComplaintGetTableData)

    // -----------Single Check ------------

    var allCheckCloneData = ""

    const handleSetData = (Data) => {

        let roleData = Data?.map((item) => ({ ...item, isChecked: false, }))
        setSingleRawData(roleData)
        roleData && roleData.forEach((item) => {
            if (item.isChecked) {
                allCheckCloneData = allCheckCloneData + item.t_ComplaintDetailsID + ","
            }
        })
        setSingleRawID(allCheckCloneData)

    }

    const handleSingleCheck = (index, data) => {
        if (SingleRawData) {
            let tempGridData = [...SingleRawData]
            tempGridData[index].isChecked = !(tempGridData[index].isChecked)
            setSingleRawData(tempGridData)
        }

        let allCheckData = ""
        SingleRawData.forEach((item) => {
            if (item.isChecked) {
                if (((RoleID == 4) && (item.m_ZoneID == null || item.m_ZoneID == 0)) || ((RoleID == 6) && (item.to_M_RoleID != 11))) {
                    allCheckData = allCheckData + item.t_ComplaintDetailsID + ","
                }
            }
            setSingleRawID(allCheckData)
            if (allCheckData == 0) {
                setIsCheckRemove(false)
            }
        })
    }

    const handleSelectAllCheck = (event) => {
        const { checked } = event.target
        setIsCheckRemove(!IsCheckRemove)
        SingleRawData.forEach((item) => {
            if (((RoleID == 4) && (item.m_ZoneID == null || item.m_ZoneID == 0)) || ((RoleID == 6) && (item.to_M_RoleID != 11))) {

                return item.isChecked = checked ? true : false
            }
        })
        setSingleRawData([...SingleRawData])

        let allCheckData = ""
        SingleRawData.forEach((item) => {
            if (item.isChecked) {
                if (((RoleID == 4) && (item.m_ZoneID == null || item.m_ZoneID == 0)) || ((RoleID == 6) && (item.to_M_RoleID != 11))) {
                    allCheckData = allCheckData + item.t_ComplaintDetailsID + ","
                }
            }

            setSingleRawID(allCheckData)
        })
    }

    return (
        <>
            {isLoading && <Loading />}
            {/* <div className="container-scroller"> */}
            <HeaderIllegal />
            <div className="wrapper bg-change">
                <EnchrochmentSidebar
                />
                <div className="content1 content mt-1 " style={{}}>

                    <div className="row">
                        <div className="col-12">
                            {/* Received Complaint */}
                            <h5 className="text-dark fw-bold ps-3 pt-2 all_heading_fontsize">{t('EncroachmentDashboard.ReceivedComplaint')}
                            </h5>
                        </div>
                    </div>
                    <div className="row ps-3 py-2 eic_table_styles" >
                        <div class="col-12 col-lg-2 pt-2">
                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.FromDate')}</label><br />
                            <input
                                className="form-control"
                                id="FromDate"
                                type="date"
                                name="FromDate"
                                value={FromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                            />
                        </div>

                        <div class="col-12 col-lg-2 pt-2">
                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.ToDate')}</label><br />
                            <input
                                className="form-control"
                                id="ToDate"
                                type="date"
                                name="ToDate"
                                value={ToDate}
                                onChange={(e) => setToDate(e.target.value)}
                                min={FromDate}
                            />
                        </div>


                        <div class="col-12 col-lg-3 pt-2">
                            <ZoneNameCommanDDL
                                ZoneNameID={ZoneNameID}
                                setZoneNameID={setZoneNameID}
                                Flag='Insert'
                                ApiFlag='UserWiseZone'
                                data=''
                                IsPost=''
                                Language={Language}
                                // ZoneValue={ZoneValue}
                                // ZoneLabel={ZoneLabel}
                                ZoneName={ZoneName}
                                ZoneID={ZoneID}
                            />
                        </div>

                        <div className="col-12 col-lg-3 col-md-4  mt-3">

                            {/* <button type="button" className="btn btn-success mx-3">Search</button> */}
                            <button type="button" className="btn btn-danger mt-4" onClick={handleClear}>Clear</button>
                        </div>
                        <div className="col-12 col-lg-2 col-md-2  mt-5">
                            {
                                (SingleRawID && SingleRawID.length > 0) &&
                                <button className="Acknowledge_button"
                                    onClick={() => {
                                        handleAcknowledge()
                                    }}
                                    title="Acknowledge"
                                >
                                    Acknowledge
                                    {/* {t('EncroachmentDashboard.View')} */}
                                </button>
                            }


                        </div>

                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                {/* <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th> */}

                                                {/* <th className=" w-6 v_sr_width">

                                                                <input type="checkbox"
                                                                    className="px-3"
                                                                    checked={IsCheckRemove}
                                                                    onClick={(e) => handleSelectAllCheck(e)}
                                                                />
                                                            </th> */}
                                                {
                                                    RoleID == 2 || RoleID == 3 ?
                                                        <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                        :
                                                        <th className=" w-6 v_sr_width">

                                                            <input type="checkbox"
                                                                className="px-3"
                                                                checked={IsCheckRemove}
                                                                onClick={(e) => handleSelectAllCheck(e)}
                                                            />
                                                        </th>

                                                }

                                                <th className="text-center">{t('EncroachmentDashboard.ComplaintReceivedDate')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.WardName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.AreaName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ComplaintUploadDate')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.complaintUploadedOfficername')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.UploadComplaintPhoto')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Remark')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.OfficerName')}</th>

                                                {
                                                    RoleID == 6 &&
                                                    <th className="text-center">{t('EncroachmentDashboard.Action')}</th>
                                                }

                                            </tr>

                                        </thead>
                                        <tbody>
                                            {
                                                SingleRawData && SingleRawData?.length > 0 ? SingleRawData?.map((i, j) => {
                                                    return (
                                                        <tr>
                                                            {/* <td className="py-1" align="center">{i.rowNum}</td> */}


                                                            {
                                                                // RoleID == 2 || RoleID == 3 || (RoleID == 6 && (i.to_M_RoleID == 11)) ?
                                                                //     <td className="py-1" align="center">{i.rowNum}</td>
                                                                //     :
                                                                // ((RoleID == 4) && (i.m_ZoneID == null || i.m_ZoneID == 0)) || ((RoleID == 6) && (i.from_M_RoleID == 2 || i.from_M_RoleID == 3 || i.from_M_RoleID == 4)) ?
                                                                ((RoleID == 4) && (i.m_ZoneID == null || i.m_ZoneID == 0)) || ((RoleID == 6) && (i.to_M_RoleID != 11)) ?

                                                                    <td align="center">
                                                                        <input type="checkbox"
                                                                            className="px-3"
                                                                            id={i.t_ComplaintDetailsID}
                                                                            name={i.t_ComplaintDetailsID}
                                                                            checked={i.isChecked}
                                                                            // checked={IsCheckRemove ? true : i.isChecked}
                                                                            value={i.t_ComplaintDetailsID}
                                                                            onClick={() => handleSingleCheck(j, i)}
                                                                        />

                                                                    </td>

                                                                    :

                                                                    // <td align="center">
                                                                    //     <input type="checkbox"
                                                                    //         className="px-3"
                                                                    //         id={i.t_ComplaintDetailsID}
                                                                    //         name={i.t_ComplaintDetailsID}
                                                                    //         // checked={i.isChecked}
                                                                    //         checked={IsCheckRemove ? true : i.isChecked}
                                                                    //         value={i.t_ComplaintDetailsID}
                                                                    //         onClick={() => handleSingleCheck(j)}
                                                                    //     />

                                                                    // </td>
                                                                    <td className="py-1" align="center" >#</td>


                                                            }

                                                            <td className="nowrap">{i.received_Date ? moment(i.received_Date).format("DD-MM-YYYY") : '-'}</td>
                                                            <td className="nowrap" >{i.zoneName ? i.zoneName : '-'}</td>
                                                            <td >{i.wardName ? i.wardName : '-'}</td>
                                                            <td >{i.encroachmentArea ? i.encroachmentArea : '-'}</td>
                                                            <td className="nowrap">{i.uploadDate ? moment(i.uploadDate).format("DD-MM-YYYY") : '-'}</td>
                                                            <td >{i.createBy_OfficerName ? i.createBy_OfficerName : '-'}</td>


                                                            <td className="text-center pt-2">
                                                                {
                                                                    (i.uploadPhoto == null) ?
                                                                        <span>-</span>
                                                                        :
                                                                        <button className="view_button " onClick={() => handleShowImage(i.uploadPhoto)}>
                                                                            {/* {t('EncroachmentDashboard.View')} */}
                                                                            <i class="fa-regular fa-image"></i>
                                                                        </button>

                                                                }

                                                            </td>

                                                            <td >{i.uploadRemark ? i.uploadRemark : '-'}</td>
                                                            <td >{i.to_OfficerName ? i.to_OfficerName : '-'}</td>

                                                            {
                                                                ((RoleID == 6) && (i.from_M_RoleID == 2 || i.from_M_RoleID == 3 || i.from_M_RoleID == 4)) ?
                                                                    <td className="text-center">

                                                                        <button className="view_button ms-2"
                                                                            onClick={() => {
                                                                                handleReturn(i)
                                                                            }}
                                                                            title="Return"
                                                                        >
                                                                            Return
                                                                            {/* {t('EncroachmentDashboard.View')} */}
                                                                        </button>

                                                                        {/* <i className="fa-solid fa-trash mx-2 text-danger fs-7 cursor-pointer"
                                                                       onClick={() => {
                                                                           setdeletePopUpShow(true)
                                                                            }}
                                                                              title="Delete">

                                                                                    </i> */}
                                                                    </td>
                                                                    :
                                                                    ((RoleID == 6) && (UserID == i.createByM_UserID)) &&
                                                                    <td>-</td>


                                                            }

                                                        </tr>
                                                    )
                                                })
                                                    :
                                                    <tr>
                                                        <td colSpan={15}>No data found ...</td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {tableData && tableData.length > 0 &&
                                    <Pegination
                                        PerPageCount={PerPageCount}
                                        TotalCount={tableData && tableData[0].totalCount}
                                        setFrom={setFrom}
                                        setTo={setTo}
                                        CurrentPage={CurrentPage}
                                        setCurrentPage={setCurrentPage}
                                        IsClear={IsClear}
                                    />
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {
                showImagePopup ?
                    <ViewURL
                        Heading={t('EncroachmentDashboard.View')}
                        setshowImagePopup={setshowImagePopup}
                        ImagePopUpData={ImagePopUpData}

                    />
                    : ''
            }

            {AcknowledgePopUpShow ?
                <ReceivedComplaintAcknowledgePopUp
                    message="Add"
                    handleAcknowledge={handleAcknowledge}
                    handleIsPost={handleIsPost}
                    SingleRawID={SingleRawID}
                /> : <></>
            }

            {/* Return */}
            {ReturnPopUpShow ?
                <ReturnPopUp
                    message="Add"
                    handleReturn={handleReturn}
                    GridData={GridData}
                    handleIsPost={handleIsPost}
                // heading="Forward"
                // cancelBtnCallBack={handleAddDepartment}
                /> : <></>
            }
        </>
    )
}

